module.exports = __webpack_public_path__ + "img/profile4.9b5828c4.jpg";